import { Typography } from "@mui/material";

interface Props {
  message: string;
}

const ErrorText = ({ message }: Props) => {
  return (
    <Typography variant="body2" color="error">
      {message}
    </Typography>
  );
};

export default ErrorText;
